/**
 * iurop-cart-drawer.js — Sidecart dinámico (Atisse, NOTAS §3.4)
 *
 * - Mutaciones de carrito DENTRO del drawer (cantidad +/- y eliminar) vía
 *   /cart/change.js con Section Rendering → re-pinta el drawer en 1 ida.
 * - Adiciones EXTERNAS (PDP, cards, upsells) van por el quick-add global de
 *   header.js, que tras añadir dispara `cart:updated` → aquí refrescamos el
 *   drawer (Section Rendering por GET) y lo ABRIMOS.
 * - Temporizador de reserva: arranca al tener ítems, persiste en localStorage,
 *   se reinicia si vacías el carrito y lo empiezas de nuevo, y cambia el copy
 *   al llegar a 0. Minutos y textos son editables (settings → Liquid).
 * - Modal Klarna (mismo contenido que la PDP), scoped al drawer.
 *
 * El abrir/cerrar base lo gestiona global.js por atributos:
 *   [data-open] en [data-cart-drawer] + [data-drawer-open] en <html>.
 */
(function () {
  'use strict';

  var RESERVE_KEY = 'iurop:cart-reserve-start';
  var reserveTimer = null;
  var busy = false;

  function drawer() {
    return document.querySelector('[data-cart-drawer]');
  }

  // --- Rodar un número (odómetro) hacia un nuevo valor ---------------------
  function rollTo(el, toText) {
    toText = String(toText);
    var from = el.getAttribute('data-roll-text');
    if (from == null) from = (el.textContent || '').trim();
    el.setAttribute('data-roll-text', toText);
    if (window.IuropRoll && from !== toText) {
      window.IuropRoll.animate(el, from, toText);
    } else {
      el.textContent = toText;
    }
  }

  // --- Contadores del HEADER (fuera del drawer; el del drawer lo hace swap) --
  function updateCounts(n) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      if (el.closest('[data-cart-drawer]')) return;
      el.classList.toggle('is-hidden', n === 0);
      rollTo(el, n);
    });
  }

  // --- Abrir / cerrar (mismo contrato que global.js) -----------------------
  function openDrawer() {
    var el = drawer();
    if (!el) return;
    el.setAttribute('data-open', 'true');
    document.documentElement.setAttribute('data-drawer-open', 'true');
  }
  function closeDrawer() {
    var el = drawer();
    if (!el) return;
    el.removeAttribute('data-open');
    document.documentElement.removeAttribute('data-drawer-open');
  }

  // --- Temporizador de reserva ---------------------------------------------
  function fmt(ms) {
    var total = Math.max(0, Math.ceil(ms / 1000));
    var m = Math.floor(total / 60);
    var s = total % 60;
    return m + ':' + (s < 10 ? '0' : '') + s;
  }

  function initReserve() {
    if (reserveTimer) {
      window.clearInterval(reserveTimer);
      reserveTimer = null;
    }
    var el = drawer();
    var bar = el && el.querySelector('[data-cart-reserve]');

    // Sin barra = carrito vacío → limpia el inicio para que reinicie al volver.
    if (!bar) {
      try { window.localStorage.removeItem(RESERVE_KEY); } catch (e) {}
      return;
    }

    var minutes = parseFloat(bar.getAttribute('data-minutes')) || 10;
    var durationMs = minutes * 60 * 1000;
    var countEl = bar.querySelector('[data-reserve-count]');
    var activeEl = bar.querySelector('[data-reserve-active]');
    var expiredEl = bar.querySelector('[data-reserve-expired]');

    var start;
    try {
      start = parseInt(window.localStorage.getItem(RESERVE_KEY), 10);
    } catch (e) {
      start = NaN;
    }
    if (!start || isNaN(start)) {
      start = Date.now();
      try { window.localStorage.setItem(RESERVE_KEY, String(start)); } catch (e) {}
    }

    var tick = function () {
      var remaining = durationMs - (Date.now() - start);
      if (remaining <= 0) {
        if (activeEl) activeEl.hidden = true;
        if (expiredEl) expiredEl.hidden = false;
        if (reserveTimer) {
          window.clearInterval(reserveTimer);
          reserveTimer = null;
        }
        return;
      }
      if (activeEl) activeEl.hidden = false;
      if (expiredEl) expiredEl.hidden = true;
      if (countEl) countEl.textContent = fmt(remaining);
    };

    tick();
    reserveTimer = window.setInterval(tick, 1000);
  }

  // --- Swap del contenido del drawer (Section Rendering) -------------------
  function swapFromHTML(html) {
    var live = drawer();
    if (!live) return;
    var parsed = new DOMParser().parseFromString(html, 'text/html');
    var next = parsed.querySelector('[data-cart-drawer]');
    if (!next) return;

    // Conserva la posición de scroll del cuerpo (único scroller) entre re-pintados.
    var oldBody = live.querySelector('.cart-drawer__body');
    var scrollTop = oldBody ? oldBody.scrollTop : 0;

    // Captura los valores VIEJOS de los números antes de re-pintar (para rodar).
    var ROLL = ['[data-cart-count]', '[data-cart-total]', '[data-cart-installment]', '[data-cart-remaining]'];
    var oldRoll = {};
    ROLL.forEach(function (sel) {
      var e = live.querySelector(sel);
      oldRoll[sel] = e ? (e.getAttribute('data-roll-text') || (e.textContent || '').trim()) : null;
    });

    live.innerHTML = next.innerHTML;

    var newBody = live.querySelector('.cart-drawer__body');
    if (newBody) newBody.scrollTop = scrollTop;

    // iOS: el estado vacío se inyecta por innerHTML y a veces no recalcula
    // alturas hasta un reflow (la rejilla de colecciones colapsaba y los
    // upsells se solapaban). Forzamos un reflow síncrono de ese bloque.
    var emptyEl = live.querySelector('.apodemia-cart-drawer__empty');
    if (emptyEl) { void emptyEl.offsetHeight; }

    // Rueda los números del drawer desde su valor viejo al nuevo (odómetro).
    ROLL.forEach(function (sel) {
      var e = live.querySelector(sel);
      if (!e) return;
      var target = e.getAttribute('data-roll-text') || (e.textContent || '').trim();
      if (oldRoll[sel] != null && window.IuropRoll && target !== oldRoll[sel]) {
        window.IuropRoll.animate(e, oldRoll[sel], target);
      }
    });

    // Contador del header (fuera del drawer) → sincroniza + rueda.
    var dc = live.querySelector('[data-cart-count]');
    var newCount = dc ? parseInt(dc.getAttribute('data-roll-text') || dc.textContent, 10) || 0 : 0;
    updateCounts(newCount);

    initReserve();
    reapplyLooks();
  }

  // --- Grupos de look (item compacto con desplegable) -----------------------
  // El estado abierto sobrevive a los re-renders del Section Rendering API.
  var openLooks = {};

  function setLookOpen(group, open) {
    var head = group.querySelector('[data-look-toggle]');
    var lines = group.querySelector('[data-look-lines]');
    if (!head || !lines) return;
    lines.hidden = !open;
    head.setAttribute('aria-expanded', open ? 'true' : 'false');
    group.classList.toggle('is-open', open);
  }

  function reapplyLooks() {
    document.querySelectorAll('[data-look-group]').forEach(function (g) {
      var key = g.getAttribute('data-look-key');
      if (key && openLooks[key]) setLookOpen(g, true);
    });
  }

  // Refresco por GET (para adiciones externas que no devuelven secciones).
  function refresh() {
    var url = window.location.pathname + '?section_id=iurop-cart-drawer';
    return fetch(url, { headers: { Accept: 'text/html' } })
      .then(function (res) { return res.ok ? res.text() : null; })
      .then(function (html) {
        if (!html) return;
        swapFromHTML(html); // ya sincroniza y rueda los contadores
      })
      .catch(function () {});
  }

  function emitCartUpdated(cart) {
    if (!cart) return;
    document.dispatchEvent(new CustomEvent('cart:updated', {
      detail: { cart: cart, drawerSynced: true }
    }));
  }

  // --- Añadir fluido (estilo DeCita) -----------------------------------------
  // IuropCart.add(items, preview): abre el sidecart AL INSTANTE con una línea
  // "optimista" (foto, nombre, variante y precio que ya conocemos en la
  // página) y en UNA sola petición (/cart/add.js + Section Rendering) trae el
  // drawer real, que sustituye a la provisional. Error → se retira la línea y
  // se enseña el mensaje de Shopify dentro del drawer.
  function esc(t) {
    return String(t == null ? '' : t).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }
  function pendingLine(pv) {
    // Clon de una línea real del carrito (mismo alto, cantidad y "Eliminar"):
    // al llegar la definitiva no salta nada. Sin líneas previas, versión básica.
    var live = drawer();
    var tpl = live && live.querySelector('[data-cart-line]:not(.apodemia-cart-drawer__item--gift):not(.apodemia-cart-drawer__item--addon)');
    var li;
    if (tpl) {
      li = tpl.cloneNode(true);
      li.removeAttribute('data-line-key');
      li.removeAttribute('data-engrave-id');
      li.removeAttribute('data-cart-line');
      li.classList.remove('is-new', 'is-removing');
      li.style.height = '';
      var img = li.querySelector('img');
      var media = li.querySelector('.apodemia-cart-drawer__item-media');
      if (img) {
        img.removeAttribute('srcset');
        img.removeAttribute('sizes');
        img.setAttribute('loading', 'eager');
        if (pv.image) img.src = pv.image; else img.remove();
      } else if (media && pv.image) {
        media.innerHTML = '<img class="apodemia-cart-drawer__item-img" alt="">';
        media.firstChild.src = pv.image;
      }
      li.querySelectorAll('.apodemia-cart-drawer__item-tag').forEach(function (t) { t.remove(); });
      var title = li.querySelector('.apodemia-cart-drawer__item-title');
      if (title) title.textContent = pv.title;
      var info = li.querySelector('.apodemia-cart-drawer__item-info');
      var variant = li.querySelector('.apodemia-cart-drawer__item-variant');
      if (pv.variant) {
        if (!variant && title) {
          variant = document.createElement('p');
          variant.className = 'apodemia-cart-drawer__item-variant';
          title.parentNode.insertBefore(variant, title.nextSibling);
        }
        if (variant) variant.textContent = pv.variant;
      } else if (variant) {
        variant.remove();
      }
      var price = li.querySelector('.apodemia-cart-drawer__item-price');
      if (price) price.textContent = pv.price || '';
      var qv = li.querySelector('.apodemia-cart-drawer__qty-value');
      if (qv) qv.textContent = '1';
      li.querySelectorAll('button, a').forEach(function (b) {
        b.removeAttribute('data-key');
        b.removeAttribute('data-qty-up');
        b.removeAttribute('data-qty-down');
        b.removeAttribute('data-cart-remove');
        b.setAttribute('tabindex', '-1');
      });
      li.style.pointerEvents = 'none';
      if (!info) li.innerHTML = '';
    } else {
      li = document.createElement('li');
      li.className = 'apodemia-cart-drawer__item';
      li.innerHTML =
        '<span class="apodemia-cart-drawer__item-media">' +
          (pv.image ? '<img class="apodemia-cart-drawer__item-img" src="' + esc(pv.image) + '" alt="">' : '') +
        '</span>' +
        '<div class="apodemia-cart-drawer__item-info">' +
          '<span class="apodemia-cart-drawer__item-title">' + esc(pv.title) + '</span>' +
          (pv.variant ? '<p class="apodemia-cart-drawer__item-variant">' + esc(pv.variant) + '</p>' : '') +
          (pv.price ? '<p class="apodemia-cart-drawer__item-price">' + esc(pv.price) + '</p>' : '') +
        '</div>';
    }
    li.classList.add('is-pending');
    li.setAttribute('data-cart-pending', '');
    return li;
  }
  // Importe "1.234,56 €" → céntimos (y al revés), para los totales optimistas.
  function toCents(t) {
    var d = String(t || '').replace(/[^\d]/g, '');
    return d ? parseInt(d, 10) : 0;
  }
  function moneyLike(sample, cents) {
    var n = (cents / 100).toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return /€\s*$/.test(sample) ? n + ' €' : (/^\s*€/.test(sample) ? '€' + n : n + ' €');
  }
  // Contadores y subtotal suben AL INSTANTE (el re-pintado deja el real).
  function optimisticTotals(previews) {
    var live = drawer();
    if (!live || !previews || !previews.length) return;
    var add = 0;
    previews.forEach(function (pv) { add += toCents(pv.price); });
    var countEl = live.querySelector('[data-cart-count]');
    var cur = countEl ? parseInt(countEl.getAttribute('data-roll-text') || countEl.textContent, 10) || 0 : 0;
    var next = cur + previews.length;
    if (countEl) { countEl.classList.remove('is-hidden'); rollTo(countEl, next); }
    updateCounts(next);
    var tot = live.querySelector('[data-cart-total]');
    if (tot && add > 0) {
      var txt = tot.getAttribute('data-roll-text') || tot.textContent;
      rollTo(tot, moneyLike(txt, toCents(txt) + add));
    }
  }
  // La foto de la línea real puede tardar un instante en cargar: mientras,
  // se ve la que ya teníamos (misma imagen del producto), sin hueco en blanco.
  function keepImages(keys, previews) {
    var live = drawer();
    if (!live) return;
    keys.forEach(function (k, idx) {
      var pv = previews && previews[idx];
      var el = live.querySelector('[data-line-key="' + k + '"]');
      var img = el && el.querySelector('img');
      if (!img || !pv || !pv.image || img.complete) return;
      var media = img.closest('.apodemia-cart-drawer__item-media') || img.parentNode;
      media.style.backgroundImage = 'url("' + pv.image.replace(/"/g, '%22') + '")';
      media.style.backgroundSize = 'cover';
      media.style.backgroundPosition = 'center';
      img.style.opacity = '0';
      img.addEventListener('load', function () { img.style.transition = 'opacity 0.2s ease'; img.style.opacity = '1'; }, { once: true });
    });
  }
  function showPending(previews) {
    var live = drawer();
    if (!live) return;
    live.classList.add('is-busy');
    if (!previews || !previews.length) return;
    var list = live.querySelector('[data-cart-items]');
    if (!list) {
      // Carrito vacío: la lista aún no existe → bloque provisional arriba.
      var body = live.querySelector('.cart-drawer__body');
      var head = body && body.querySelector('.apodemia-cart-drawer__head');
      if (!body) return;
      var empty = body.querySelector('.apodemia-cart-drawer__empty');
      if (empty) empty.hidden = true;
      list = document.createElement('ul');
      list.className = 'apodemia-cart-drawer__items';
      list.setAttribute('data-cart-pending', '');
      if (head && head.nextSibling) body.insertBefore(list, head.nextSibling);
      else body.appendChild(list);
    }
    previews.slice().reverse().forEach(function (pv) {
      if (pv && pv.title) list.insertBefore(pendingLine(pv), list.firstChild);
    });
    var sc = live.querySelector('.cart-drawer__body');
    if (sc) sc.scrollTop = 0;
  }
  function clearPending() {
    var live = drawer();
    if (!live) return;
    live.classList.remove('is-busy');
    live.querySelectorAll('[data-cart-pending]').forEach(function (el) { el.remove(); });
    var empty = live.querySelector('.apodemia-cart-drawer__empty');
    if (empty) empty.hidden = false;
  }
  function showError(msg) {
    var live = drawer();
    var body = live && live.querySelector('.cart-drawer__body');
    if (!body || !msg) return;
    var old = body.querySelector('[data-cart-error]');
    if (old) old.remove();
    var p = document.createElement('p');
    p.className = 'apodemia-cart-drawer__error';
    p.setAttribute('data-cart-error', '');
    p.setAttribute('role', 'alert');
    p.textContent = msg;
    var head = body.querySelector('.apodemia-cart-drawer__head');
    body.insertBefore(p, head ? head.nextSibling : body.firstChild);
    window.setTimeout(function () { if (p.parentNode) p.remove(); }, 6000);
  }
  function markNew(keys) {
    var live = drawer();
    if (!live || !keys.length) return;
    keys.forEach(function (k) {
      var el = live.querySelector('[data-line-key="' + k + '"]');
      if (!el) return;
      el.classList.add('is-new');
      window.setTimeout(function () { el.classList.remove('is-new'); }, 900);
    });
  }
  function fluidAdd(items, previews) {
    openDrawer();
    showPending(previews);
    optimisticTotals(previews);
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: items,
        sections: 'iurop-cart-drawer',
        sections_url: window.location.pathname
      })
    })
      .then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok) throw data;
          return data;
        });
      })
      .then(function (data) {
        if (data && data.sections && data.sections['iurop-cart-drawer']) {
          swapFromHTML(data.sections['iurop-cart-drawer']);
        } else {
          return refresh().then(function () { return data; });
        }
        return data;
      })
      .then(function (data) {
        var live = drawer();
        if (live) live.classList.remove('is-busy');
        keepImages(((data && data.items) || []).map(function (it) { return it.key; }), previews);
        // El resto de la página (contadores, barras) se entera sin bloquear.
        fetch('/cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(emitCartUpdated)
          .catch(function () {});
        return data;
      })
      .catch(function (err) {
        clearPending();
        showError((err && (err.description || err.message)) || '');
        throw err;
      });
  }
  window.IuropCart = window.IuropCart || {};
  window.IuropCart.add = fluidAdd;
  window.IuropCart.open = function () { openDrawer(); };
  window.IuropCart.refresh = function () { return refresh(); };

  // --- Cambiar cantidad / eliminar línea (change.js + secciones) -----------
  // --- UI optimista: quitar/cambiar cantidad se ve AL INSTANTE ------------
  // La línea se pliega (o cambia su número) antes de que responda Shopify; el
  // re-pintado posterior deja el estado real. Las peticiones se encolan para
  // no perder clics seguidos.
  var queue = Promise.resolve();
  function optimistic(updates) {
    var live = drawer();
    if (!live) return;
    Object.keys(updates).forEach(function (key) {
      var line = live.querySelector('[data-cart-line][data-line-key="' + key + '"]');
      if (!line) return;
      var q = updates[key];
      if (q <= 0) {
        line.style.height = line.offsetHeight + 'px';
        void line.offsetHeight;
        line.classList.add('is-removing');
        line.style.height = '0px';
      } else {
        var v = line.querySelector('.apodemia-cart-drawer__qty-value');
        if (v) v.textContent = q;
        line.querySelectorAll('[data-qty-up], [data-qty-down]').forEach(function (b) { b.setAttribute('data-qty', q); });
      }
    });
    live.classList.add('is-busy');
  }
  function enqueue(fn) {
    queue = queue.then(fn, fn);
    return queue;
  }

  function changeLine(key, quantity) {
    var u = {}; u[key] = quantity;
    optimistic(u);
    return enqueue(function () { return changeLineNow(key, quantity); });
  }

  function changeLineNow(key, quantity) {
    busy = true;
    var el = drawer();
    if (el) el.setAttribute('data-busy', 'true');

    var changeUrl = (window.routes && window.routes.cart_change_url) || '/cart/change';
    return fetch(changeUrl + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        id: key,
        quantity: quantity,
        sections: 'iurop-cart-drawer',
        sections_url: window.location.pathname
      })
    })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var sync;
        if (cart && cart.sections && cart.sections['iurop-cart-drawer']) {
          swapFromHTML(cart.sections['iurop-cart-drawer']); // sincroniza contadores
        } else {
          sync = refresh();
        }
        return Promise.resolve(sync).then(function () { emitCartUpdated(cart); });
      })
      .catch(function () { return refresh(); })
      .then(function () {
        busy = false;
        var d = drawer();
        if (d) { d.removeAttribute('data-busy'); d.classList.remove('is-busy'); }
      });
  }

  // Actualiza varias líneas a la vez (p. ej. quitar joya + su grabado juntos).
  function updateLines(updates) {
    optimistic(updates);
    return enqueue(function () { return updateLinesNow(updates); });
  }

  function updateLinesNow(updates) {
    busy = true;
    var el = drawer();
    if (el) el.setAttribute('data-busy', 'true');
    var updateUrl = (window.routes && window.routes.cart_update_url) || '/cart/update';
    return fetch(updateUrl + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        updates: updates,
        sections: 'iurop-cart-drawer',
        sections_url: window.location.pathname
      })
    })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var sync;
        if (cart && cart.sections && cart.sections['iurop-cart-drawer']) {
          swapFromHTML(cart.sections['iurop-cart-drawer']);
        } else {
          sync = refresh();
        }
        return Promise.resolve(sync).then(function () { emitCartUpdated(cart); });
      })
      .catch(function () { return refresh(); })
      .then(function () {
        busy = false;
        var d = drawer();
        if (d) { d.removeAttribute('data-busy'); d.classList.remove('is-busy'); }
      });
  }

  // --- Añadir upsell ("Combínalo con") dentro del drawer -------------------
  function addLine(variantId) {
    if (busy) return;
    busy = true;
    var el = drawer();
    if (el) el.setAttribute('data-busy', 'true');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: 1 }],
        sections: 'iurop-cart-drawer',
        sections_url: window.location.pathname
      })
    })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        var sync;
        if (data && data.sections && data.sections['iurop-cart-drawer']) {
          swapFromHTML(data.sections['iurop-cart-drawer']);
        } else {
          sync = refresh();
        }
        return Promise.resolve(sync)
          .then(function () { return fetch('/cart.js', { headers: { Accept: 'application/json' } }); })
          .then(function (res) { return res.ok ? res.json() : null; })
          .then(emitCartUpdated);
      })
      .catch(function () {})
      .then(function () {
        busy = false;
        var d = drawer();
        if (d) d.removeAttribute('data-busy');
      });
  }

  // --- Modal Klarna --------------------------------------------------------
  function klarnaModal() {
    var el = drawer();
    return el && el.querySelector('[data-cart-klarna]');
  }
  function openKlarna() {
    var m = klarnaModal();
    if (m) m.hidden = false;
  }
  function closeKlarna() {
    var m = klarnaModal();
    if (m) m.hidden = true;
  }

  // --- Delegación de eventos ----------------------------------------------
  document.addEventListener('click', function (e) {
    var up = e.target.closest('[data-qty-up]');
    if (up) {
      e.preventDefault();
      var q = (parseInt(up.getAttribute('data-qty'), 10) || 0) + 1;
      changeLine(up.getAttribute('data-key'), q);
      return;
    }

    var down = e.target.closest('[data-qty-down]');
    if (down) {
      e.preventDefault();
      var cur = parseInt(down.getAttribute('data-qty'), 10) || 0;
      changeLine(down.getAttribute('data-key'), Math.max(0, cur - 1));
      return;
    }

    var lt = e.target.closest('[data-look-toggle]');
    if (lt) {
      e.preventDefault();
      var group = lt.closest('[data-look-group]');
      if (group) {
        var key = group.getAttribute('data-look-key') || '';
        var open = !group.classList.contains('is-open');
        openLooks[key] = open;
        setLookOpen(group, open);
      }
      return;
    }

    var remove = e.target.closest('[data-cart-remove]');
    if (remove) {
      e.preventDefault();
      var rKey = remove.getAttribute('data-key');
      var rLine = remove.closest('[data-cart-line]');
      var engId = rLine && rLine.getAttribute('data-engrave-id');
      if (engId) {
        // Al quitar la joya grabada, se quita también su línea de servicio (+precio).
        var upd = {};
        upd[rKey] = 0;
        document.querySelectorAll('[data-cart-line][data-engrave-id="' + engId + '"]').forEach(function (l) {
          var k = l.getAttribute('data-line-key');
          if (k) upd[k] = 0;
        });
        updateLines(upd);
        return;
      }
      changeLine(rKey, 0);
      return;
    }

    var add = e.target.closest('[data-cart-add]');
    if (add) {
      e.preventDefault();
      addLine(parseInt(add.getAttribute('data-cart-add'), 10));
      return;
    }

    if (e.target.closest('[data-cart-klarna-open]')) {
      e.preventDefault();
      openKlarna();
      return;
    }
    if (e.target.closest('[data-cart-klarna-close]')) {
      e.preventDefault();
      closeKlarna();
      return;
    }
  });

  // Esc: cierra primero el modal Klarna (captura → corta el cierre del drawer
  // que hace global.js en fase de burbuja).
  document.addEventListener(
    'keydown',
    function (e) {
      if (e.key !== 'Escape') return;
      var m = klarnaModal();
      if (m && !m.hidden) {
        closeKlarna();
        e.stopPropagation();
      }
    },
    true
  );

  // Adición externa → refresca el contenido. Por defecto abre el drawer; con
  // detail.noOpen (p. ej. el modal quick-view / hero) solo refresca en silencio
  // para no tapar el modal con el sidecart.
  document.addEventListener('cart:updated', function (e) {
    if (e && e.detail && e.detail.drawerSynced) return;
    if (e && e.detail && e.detail.noOpen) {
      refresh();
    } else {
      // Abre YA (con el drawer en estado "cargando") y re-pinta al llegar.
      openDrawer();
      var live = drawer();
      if (live) live.classList.add('is-busy');
      refresh().then(function () {
        var l = drawer();
        if (l) l.classList.remove('is-busy');
      });
    }
  });

  // --- Swipe para cerrar (móvil / iOS) -------------------------------------
  // El panel entra por la derecha → arrastrar a la derecha lo descarta. Solo se
  // activa si el gesto es claramente horizontal (no al hacer scroll vertical).
  var swStartX = null, swStartY = null, swPanel = null, swActive = false;

  document.addEventListener('touchstart', function (e) {
    var p = e.target.closest('[data-cart-panel]');
    if (!p) return;
    swStartX = e.touches[0].clientX;
    swStartY = e.touches[0].clientY;
    swPanel = p;
    swActive = false;
  }, { passive: true });

  document.addEventListener('touchmove', function (e) {
    if (swStartX === null || !swPanel) return;
    var dx = e.touches[0].clientX - swStartX;
    var dy = e.touches[0].clientY - swStartY;
    if (!swActive) {
      if (Math.abs(dx) < 8 && Math.abs(dy) < 8) return;
      // Bloquea el gesto como swipe solo si domina el eje X hacia la derecha.
      swActive = dx > 0 && Math.abs(dx) > Math.abs(dy);
      if (!swActive) { swStartX = null; swPanel = null; return; }
    }
    if (dx > 0) {
      swPanel.style.transition = 'none';
      swPanel.style.transform = 'translateX(' + dx + 'px)';
    }
  }, { passive: true });

  document.addEventListener('touchend', function (e) {
    if (swStartX === null || !swPanel) return;
    var dx = e.changedTouches[0].clientX - swStartX;
    var panel = swPanel;
    panel.style.transition = '';
    panel.style.transform = '';
    if (swActive && dx > panel.offsetWidth * 0.33) {
      closeDrawer();
    }
    swStartX = null; swStartY = null; swPanel = null; swActive = false;
  }, { passive: true });

  // Init
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initReserve);
  } else {
    initReserve();
  }
})();
